import React, { FC } from 'react';
import InlineDialog from '@atlaskit/inline-dialog';
import Button from '@atlaskit/button';
import { IndicatorFailureDTO } from '@atlassiansox/phobos-client-ts';

import { useOpenableController } from '@/controllers';
import { listReset } from '@/styles';
import LogItem, {
  LogItemProps,
  LogItemSeverity,
} from '@/components/composed/slo-card/graph/fault-zone/log-item';
import { SLOGraphWarning } from '@/controllers/slo-graph-controller/warnings';

import * as styles from './log-styles';

interface IProps {
  errorLog?: IndicatorFailureDTO[];
  warnings?: SLOGraphWarning[];
}

const getLogItems = (log?: IndicatorFailureDTO[], warnings?: SLOGraphWarning[]) => {
  const logItems: LogItemProps[] = [];

  warnings?.forEach(({ title, message, severity, docLink }) => {
    logItems.push({
      title,
      message,
      severity,
      docLink,
    });
  });

  log?.forEach(({ cause, timestamp }) => {
    logItems.push({
      message: cause,
      timestamp,
      severity: LogItemSeverity.LOG,
    });
  });

  return logItems;
};

const Log: FC<IProps> = ({ errorLog, warnings }) => {
  const { onClose, onToggle, isOpen } = useOpenableController();

  return (
    <div css={[styles.root]}>
      <InlineDialog
        onClose={onClose}
        isOpen={isOpen}
        content={
          <ol css={[listReset]}>
            {getLogItems(errorLog, warnings).map(
              ({ title, message, timestamp, severity, docLink }) => (
                <LogItem
                  key={
                    (timestamp instanceof Date ? timestamp.toISOString() : timestamp || '') +
                    message
                  }
                  title={title}
                  message={message}
                  timestamp={timestamp}
                  severity={severity}
                  docLink={docLink}
                />
              )
            )}
          </ol>
        }
        testId="slo-graph-error-log"
      >
        <Button
          appearance="link"
          spacing="none"
          onClick={onToggle}
          testId="slo-card-error-log-link-button"
        >
          See error log
        </Button>
      </InlineDialog>
    </div>
  );
};

export default Log;
